export function Google(url){
  return new Promise((resolve, reject) => {
    ((d, s, id) => {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        resolve(google)
      } else {
        js = d.createElement(s);
        js.id = id;
        js.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAgdbFryiGxhViWR1KEI5rACTFJj05jGsk&language=en&libraries=places&v=weekly";
        fjs.parentNode.insertBefore(js, fjs);
        js.onload = () => {
          resolve(google)
        };
      }
    })(document, "script", "googleMapSdk");
  })
}


// WEBPACK FOOTER //
// ./src/utils/importGoogle.js